// extracted by mini-css-extract-plugin
export default {"root":"iLnAz__root"};